module.exports = __webpack_public_path__ + "gb-sct.6380e60f440d2a09863a.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/gb-sct.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/gb-sct.svg
// module chunks = styles